import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import useNavegacao from '../../hooks/useNavegacao';

const ModalValidacaoAceite = ({ visible }) => {
    const { navegarParaListaContratos } = useNavegacao();

    const footer = (
        <>
            <Button
                label="Ok"
                onClick={navegarParaListaContratos}
            />
        </>
    );

    return (
        <Dialog
            footer={footer}
            visible={visible}
            closable={false}
        >
            <p className = "mensagem-erro-aceite">Este contrato não pode ser editado, pois já possui aceite.</p>

        </Dialog>
    );
};

export default ModalValidacaoAceite;